import React from 'react';

import DashboardLayout from './DashboardLayout';
import GenericNotFound from './GenericNotFound';

export default () => (
  <DashboardLayout>
    <GenericNotFound />
  </DashboardLayout>
)


// WEBPACK FOOTER //
// ./src/components/PageNotFound.js